import { render, staticRenderFns } from "./ResourceManageUpload.vue?vue&type=template&id=0361146b&scoped=true&"
import script from "./ResourceManageUpload.vue?vue&type=script&lang=js&"
export * from "./ResourceManageUpload.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/css/chunkUpload.css?vue&type=style&index=0&id=0361146b&scoped=true&lang=css&"
import style1 from "../../../assets/css/resources.css?vue&type=style&index=1&id=0361146b&scoped=true&lang=css&"
import style2 from "./ResourceManageUpload.vue?vue&type=style&index=2&id=0361146b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0361146b",
  null
  
)

export default component.exports